<template>
  <div id="app">
					<div class="text-center">
            <div class="row">
              <div class="col-md-4"></div>

            <div class="col-md-4 offset-ml-auto">
<div class="form-group">
  <label for="sel1">Vyber projekt:</label>
  <select class="form-control" id="sel1" v-model="currentProject.project" v-bind:disabled="hasActiveProject" @change="projectChanged">
    <option v-for="(project, index) in projects" :key="index" :value="project.name">{{ project.name }}</option>
  </select>
  <br>
  <div v-if="currentProject.type == 'drive'">
    <label for="sel1">Vyber auto:</label>
  <select class="form-control" id="sel1" v-model="currentProject.plate" v-bind:disabled="hasActiveProject">
    <option v-for="(car, index) in cars" :key="index" :value="car.plate">{{ car.name }} ({{car.plate}})</option>
  </select>
</div>
<br>
<div v-if="!hasActiveProject && currentProject.type == 'drive'">
  <label>Začiatočné kilometre</label>
  <input type="text" class="form-control" v-model="currentProject.start_km">
</div>

<div v-if="hasActiveProject && currentProject.type == 'drive'">
  <label>Konečné kilometre</label>
  <input type="text" class="form-control" v-model="currentProject.end_km">
</div>


  <hr>
						<button v-if="!hasActiveProject" type="button" href="#" class="txt2 hov1" @click="startProject" v-bind:disabled="(currentProject.type == 'drive' && (!currentProject.plate || currentProject.start_km == 0))">
							Začiatok
						</button>
						<button v-if="hasActiveProject" type="button" href="#" class="txt2 hov1" @click="endProject">
							Koniec
						</button>

</div>

</div>
<br><br>
<div class="container">
  <button class="btn btn-primary" @click="loadMonthlyData(false)">Predchádzajúci mesiac</button> &nbsp;
  <button class="btn btn-primary" @click="loadMonthlyData(true)">Tento mesiac</button>
  <br><hr><br>
    <table class="table table-striped" style="text-align:left">
    <thead style="text-align:left">
      <tr style="text-align:left">
        <th>Dátum</th>
        <th>Projekt + čas bez prestávok</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="m in selectedMonth" :key="m.day" :style="m.projects.length == 0 ? { 'background-color': 'orange'} : ''">
        <td>{{m.date | moment("DD/MM/YYYY")}}</td>
        <td v-if="m.projects.length > 0">
          <p v-for="(p, index) in m.projects" :key="index">{{p.project}} ({{new Date(p.begin.seconds * 1000) | moment("DD/MM/YYYY HH:mm:ss")}} až {{new Date(p.end.seconds * 1000) | moment("DD/MM/YYYY HH:mm:ss")}} - spolu odrobených {{ p.seconds}})</p>
        </td>
        <td v-else><i>Voľno</i></td>
      </tr>

    </tbody>
  </table>

</div>
</div>
					</div>
  </div>
</template>

<script>
import moment from 'moment'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'
import firebase from 'firebase'

export default {
  name: 'Tracker',
  data() {
    return {
      loaded : false,
      error : '',
      projects : [],
      cars : [],
      currentProject : {
        id : "",
        begin : null,
        end : null,
        project : "",
        plate : "",
        type : "",
        start_km : 0,
        end_km : 0,
        email : ""
      },
      hasActiveProject : false,
      selectedMonth : [],
      day : {
        number : null,
      }
    }
  },
  methods : {
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hodina, " : " hodín, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minúta, " : " minút, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " sekunda" : " sekúnd") : "";
      return hDisplay + mDisplay + sDisplay; 
    },
    loadMonthlyData(current)
    {
      
      this.selectedMonth = [];
      
      let month = null;
      if(current)
      month = moment().month() + parseInt(1);
      else
      month = moment().month();
      
        

      for(var i = 1; i <= moment().daysInMonth(); i++)
      {
        
        let cdate = new Date("2020-"+month+"-"+i);      
        let end = new Date("2020-"+month+"-"+i + " 23:59:59");
        let day = {
          day : i,
          date: cdate,
          projects : []
        };
        
        firebase.firestore().collection('timer').where('email', '==', this.$store.getters.user.email).
        where('begin', '>', cdate).where('begin', '<', end).get().then(async data => {
          this.error = "lele";
          if(data.docs.length > 0)
          {
            
            data.docs.forEach(p => {
              if(p.data().begin != null & p.data().end != null)
              {
                let seconds = p.data().end.seconds - p.data().begin.seconds;
                console.log("odrobenych " + seconds)
                console.log(p.data());
                Object.assign(p.data(), {'seconds' : seconds});
                let newRecord = {
                  type : p.data().type,
                  project : p.data().project,
                  end : p.data().end,
                  begin : p.data().begin,
                  start_km : p.data().start_km,
                  end_km : p.data().end_km,
                  seconds : this.secondsToHms(seconds)
                };
                day.projects.push(newRecord);
              }
            });
          }
          //day.projects.push(data.docs);
        }).catch(e => {
          this.error = "erorr";
        });      

          this.selectedMonth.push(day);
      }
    },
    async fetchCars()
    {
            await firebase.firestore().collection('vehicle').get().then(snap => {
        
        if(!snap.empty)
        {
          this.cars = snap.docs.map(x => x.data());
        }
        else
        {
          console.log("snap was empty");
        }
      });

    },
    projectChanged(e)
    {
      
      var proj = this.projects.find(x => x.name == e.target.value);
      this.currentProject.type = proj.type;

    if(this.currentProject.type == 'drive')
    {
      this.fetchCars(); 
    }

    },
    async startProject()
    {
            var toast = this.$toast;

      if(this.currentProject.project == "" || this.currentProject.project == null)
      {
        toast.error('Prosím vyber projekt.');
        return;
      }

      if(!this.hasActiveProject)
      {
        const pr = firebase.firestore().collection('timer');

        await pr.doc().set({
          project: this.currentProject.project,
          begin: new Date(),
          end : null,
          email : firebase.auth().currentUser.email,
          type : this.currentProject.type,
          start_km : this.currentProject.start_km,
          plate : this.currentProject.plate
        }, {merge: true});
      }

      this.getActiveProject();

    },
    async endProject()
    {
      await firebase.firestore().collection('timer').where('email', '==', firebase.auth().currentUser.email).where('end', '==', null).get().then( snap => {
        snap.forEach( doc => {
          if(this.currentProject.type == 'drive')
            doc.ref.update({end:new Date(), end_km: this.currentProject.end_km});
          else
            doc.ref.update({end:new Date()});
        })
      });

      //this.getActiveProject();
      this.hasActiveProject = false;
    },
    async getActiveProject()
    {
      await firebase.firestore().collection('timer').where('email', '==', firebase.auth().currentUser.email)
      .where('end', '==', null)
      .limit(1).get().then(snap => {
     
        if(!snap.empty)
        {
          this.currentProject = snap.docs[0].data();
          this.hasActiveProject = true;
        }
        else
        {
          this.hasActiveProject = false;
          console.log("snap was empty");
        }
      });

    },
        async getData()
    {
      this.error = 'getting data';
      await firebase.firestore().collection('user').where('email', '==', firebase.auth().currentUser.email).limit(1).get().then(snap => {

      });
    await firebase.firestore().collection('project').get().then(snap => {
      this.projects = snap.docs.map(x => x.data());
      
    });


    }
  },
  created()
  {
  
    if(!firebase.auth().currentUser)
    {

      firebase.auth().signInWithEmailAndPassword(localStorage.getItem('email'), localStorage.getItem('password')).then( res => {
      
        this.$store.commit('userLoggedIn');
    this.getData();
    this.getActiveProject();

      } ).catch(function(error) {
              this.$router.push('login');

        /*var errorCode = error.code;
        var errorMessage = error.message;*/
        // ...
      });

    } else  {
              this.$store.commit('userLoggedIn');

          this.getData();
    this.getActiveProject();

    }

    this.fetchCars();
  this.loadMonthlyData();

    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
